import React, { useState } from 'react';

import EditLineIcon from '../../../../../design-system/Icons/EditLineIcon';
import TabEditorModal from '../TabEditorModal/TabEditorModal';
import DeleteTabModal from '../DeleteTabModal/DeleteTabModal';
import { SvgIcon, Toggle } from '../../../../../design-system';
import { DeleteBin4LineIcon } from '../../../../../design-system/Icons';

const TabCard = ({ tab, setTabs, playbookId }) => {
    const { order, type, label, is_live } = tab;

    const [actionModal, setActionModal] = useState({ action: null });

    const updateCurrentTab = (cb) => {
        setTabs((tabs) =>
            tabs.map((tab) => {
                if (tab.order !== order) return tab;

                return typeof cb === 'function' ? cb(tab) : { ...tab, ...cb };
            })
        );
    };

    const onToggleChange = (is_live) => updateCurrentTab({ is_live });
    const closeActionModal = () => setActionModal({ action: null });

    return (
        <li className="py-1 flex items-start justify-between gap-3 border-b border-neutral-200">
            <div className="flex items-start gap-3">
                <Toggle isSelected={is_live} name="is_live" onChange={onToggleChange} size="sm" />
                <p className="min-h-[20px] flex items-center font-body-bold text-body-bold-s text-neutral-500">
                    {label}
                </p>
            </div>

            <div className="flex items-center gap-3 min-h-[20px]">
                <button
                    onClick={() => setActionModal({ action: 'edit' })}
                    className="text-neutral-500 disabled:text-neutral-300"
                >
                    <SvgIcon color="currentColor" icon={EditLineIcon} size="medium" />
                </button>
                <button
                    onClick={() => setActionModal({ action: 'delete' })}
                    className="text-neutral-500 disabled:text-neutral-300"
                >
                    <SvgIcon color="currentColor" icon={DeleteBin4LineIcon} size="medium" />
                </button>
            </div>

            {actionModal.action === 'edit' && (
                <TabEditorModal
                    mode="edit"
                    data={tab}
                    type={type}
                    playbookId={playbookId}
                    setEditedTab={updateCurrentTab}
                    onClose={closeActionModal}
                />
            )}

            {actionModal.action === 'delete' && (
                <DeleteTabModal
                    label={label}
                    order={order}
                    setTabs={setTabs}
                    onClose={closeActionModal}
                />
            )}
        </li>
    );
};

export default TabCard;
